import type { ReactNode } from "react";
import { Button } from "./Button";

interface EmptyStateProps {
  title: string;
  description: string;
  action?: ReactNode;
}

export function EmptyState({ title, description, action }: EmptyStateProps) {
  return (
    <div className="px-6 py-[45px] text-center">
      <p aria-hidden className="mb-3 text-2xl text-[#97a9a0]">
        ◌
      </p>
      <h3 className="mb-[6px] text-base font-semibold text-edlab-ink">{title}</h3>
      <p className="mx-auto max-w-[400px] text-sm text-edlab-muted">{description}</p>
      {action ? <div className="mt-6 flex justify-center">{action}</div> : null}
    </div>
  );
}

interface FeatureShellProps {
  title: string;
  description: string;
  phaseNote: string;
}

export function FeatureShell({ title, description, phaseNote }: FeatureShellProps) {
  return (
    <div>
      <EmptyState
        title={title}
        description={description}
        action={
          <Button variant="secondary" disabled>
            {phaseNote}
          </Button>
        }
      />
    </div>
  );
}
